module.exports = __webpack_public_path__ + "static/img/more.68d2bbea.svg";